import styled, { css } from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";
import type { InstanceHealth } from "./InstanceListItem.types";

// Health indicator dot — 8px matches the existing StatusPill convention
// (no shared token exists for status-dot sizes yet).
const DOT_SIZE = "8px";

export const Item = styled.button<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  // gap: ${spacing[1]};
  width: 100%;
  text-align: left;
  background: transparent;
  border: 0;
  border-right: ${({ theme }) => theme.borders.width[2]} ${({ theme }) =>
    theme.borders.style.solid} transparent;
  padding: ${spacing[2]} ${spacing[3]};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.primary};
  transition: background-color
    ${({ theme }) => theme.transitions.durations.fast}
    ${({ theme }) => theme.transitions.easing.easeOut};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary[50]};
  }

  &:focus-visible {
    outline: ${({ theme }) => theme.borders.width[2]} ${({ theme }) =>
      theme.borders.style.solid} ${rawColors.primary[500]};
    outline-offset: -${({ theme }) => theme.borders.width[2]};
  }

  ${({ $selected, theme }) =>
    $selected &&
    css`
      background-color: ${theme.colors.primary[50]};
      border-right-color: ${theme.colors.text.interactive};
    `}
`;

export const NameRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
`;

export const HealthDot = styled.span<{ $health: InstanceHealth }>`
  display: inline-block;
  width: ${DOT_SIZE};
  height: ${DOT_SIZE};
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${({ $health, theme }) =>
    $health === "warning"
      ? theme.colors.warning[500]
      : $health === "error"
        ? theme.colors.error[500]
        : theme.colors.success[500]};
`;

export const Name = styled.span`
  ${typographyMixin("body", 3)}
`;

export const LastSync = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.tertiary};
`;
